
import CallReceived from "../../../assets/duotone/CallReceived.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CallReceivedIcon({ className, dataTestid = "CallReceivedIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CallReceived data-testid={dataTestid} className={classes} {...rest} />
  );
}
